module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_kinrgy-6de92612691597fc6a831124218848e6.png";